import { render } from "./TheHeader.vue?vue&type=template&id=7fc5c1b6"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=7fc5c1b6&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script